const termDefaults = {
    short_term: [],
    medium_term: [],
    long_term: []
};

export default termDefaults;